import {
  HttpInterceptorFn,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { LoadingService } from "../services/loading.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const loadingService = inject(LoadingService);


  // Skip token for login requests
  if (req.url.includes("/api/auth/login")) {
    return next(req);
  }

  // For all other requests, add token if available
  if (token) {
    const headers = new HttpHeaders({
      ...req.headers.keys().reduce(
        (acc, key) => ({
          ...acc,
          [key]: req.headers.get(key),
        }),
        {}
      ),
      Authorization: `Bearer ${token}`,
    });

    // Clone the request with the new headers
    const authReq = req.clone({ headers });

    // Handle response errors, especially 401 Unauthorized
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error(
            "Authentication failed. Token may be invalid or expired."
          );
          loadingService.hide();
          authService.logout();
          router.navigate(["/login"], {
            queryParams: { error: "session_expired" },
          });

          return throwError(
            () => new Error("Authentication failed. Please log in again.")
          );
        }
        return throwError(() => error);
      })
    );
  } else {
    console.warn("No token available for authenticated request");
  }

  return next(req);
};
